module.exports = __webpack_public_path__ + "static/media/welcome-page-logo.a0f02dde.png";